// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1pL3j","actionsCol":"EnrolledClinics_actionsCol__2ABF7"};